import { render, staticRenderFns } from "./storeOrderReview.vue?vue&type=template&id=490b5ba2&scoped=true&"
import script from "./storeOrderReview.vue?vue&type=script&lang=js&"
export * from "./storeOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./storeOrderReview.vue?vue&type=style&index=0&id=490b5ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b5ba2",
  null
  
)

export default component.exports